// extracted by mini-css-extract-plugin
export var deleteModal = "_fl-0";